module.exports = __webpack_public_path__ + "static/media/rated.910147a9.png";